import type {BankTransferDetails} from "@/components/children/bankTransferDetails/scripts/types";
import {AccountingPeriod} from "@/Enums";

const createEmptyBankTransferDetails = () => {
  const bankTransferDetails: BankTransferDetails = {
    id: 0,
    reference: undefined,
    creditAccountingPeriod: AccountingPeriod.daily,
    creditPeriodStartDate: null,
    creditLastExportDate: null,
    creditNextExportDate: null,
  }

  return bankTransferDetails;
}

const resetBankTransferDetails = (originalObject: BankTransferDetails, changedObject: BankTransferDetails) => {
  changedObject.id = originalObject.id;
  changedObject.reference = originalObject.reference;
  changedObject.creditAccountingPeriod = originalObject.creditAccountingPeriod;
  changedObject.creditPeriodStartDate = originalObject.creditPeriodStartDate;
  changedObject.creditLastExportDate = originalObject.creditLastExportDate;
  changedObject.creditNextExportDate = originalObject.creditNextExportDate;
}

const bankTransferDetailsHaveChanges = (originalObject: BankTransferDetails, changedObject: BankTransferDetails) => {
  return originalObject.id !== changedObject.id
    || originalObject.reference !== changedObject.reference
    || originalObject.creditAccountingPeriod !== changedObject.creditAccountingPeriod
    || originalObject.creditPeriodStartDate !== changedObject.creditPeriodStartDate;
}

export {
  createEmptyBankTransferDetails,
  resetBankTransferDetails,
  bankTransferDetailsHaveChanges
}
